module.exports = __webpack_public_path__ + "static/media/apple_bodytype.7915dc02.png";